import React from 'react'
import { Label as UILabel } from '@faststore/ui'
import Checkbox from 'src/components/ui/Checkbox'
import { normalize } from 'src/utils/similars'
import type { ValuesObjectProps } from 'src/components/search/Filter/types'
import type { IStoreSelectedFacet } from '@faststore/api'

import storeConfig from '../../../../../../../../store.config'

interface IFilterItem {
  id: string
  itemValues: ValuesObjectProps
  testId: string
  label: string
  selectedFacets: IStoreSelectedFacet[]
  keyValue: string
  testFacets: (facetValue: string, itemValue: string) => boolean
  onFacetChange: (item: IStoreSelectedFacet) => void
  isFallbackImgFilter: Array<{
    label: string
    index: string
  }>
  setIsFallbackImgFilter: React.Dispatch<
    React.SetStateAction<
      Array<{
        label: string
        index: string
      }>
    >
  >
}

export default function FilterItem({
  id,
  itemValues,
  testId,
  label,
  selectedFacets,
  keyValue,
  testFacets,
  onFacetChange,
  isFallbackImgFilter,
  setIsFallbackImgFilter,
}: IFilterItem) {
  const { account } = storeConfig

  const generateImgURL = (itemLabel: string) => {
    const labelNormalized = normalize(label)
    const itemLabelNormalized = normalize(itemLabel)

    if (labelNormalized === 'material') {
      return `https://${account}.vtexassets.com/arquivos/similaridade__material__${itemLabelNormalized}.png`
    }

    if (labelNormalized.includes('pedra')) {
      return `https://${account}.vtexassets.com/arquivos/similaridade__pedra__${itemLabelNormalized}.png`
    }

    return null
  }

  const imgURL = generateImgURL(itemValues?.label)

  return (
    <>
      <Checkbox
        id={id}
        checked={selectedFacets
          .filter((facet) => facet.key !== 'price' && facet.key === keyValue)
          .some((facet2) => testFacets(facet2.value, itemValues?.value))}
        onChange={() =>
          onFacetChange({ key: keyValue, value: itemValues?.value })
        }
        data-testid={`${testId}-accordion-panel-checkbox`}
        data-value={itemValues?.value}
        data-quantity={itemValues?.quantity}
      />
      {imgURL && (
        <>
          <img
            alt={`Imagem de ${itemValues?.label}`}
            src={imgURL}
            onError={(e) => {
              const target = e?.target as HTMLImageElement

              target.style.display = 'none'
              setIsFallbackImgFilter((rest) => [
                ...rest,
                { index: itemValues?.label, label },
              ])
            }}
            className="imgAccordion"
          />
          {isFallbackImgFilter.some(
            (fallback) =>
              fallback.index === itemValues?.label && fallback.label === label
          ) && <div className="fallbackImg" />}
        </>
      )}
      <UILabel htmlFor={id} className="title-small">
        {itemValues?.label}
      </UILabel>
      <span>({itemValues?.quantity})</span>
    </>
  )
}
